import { StatusNameEnum } from "common/enums/StatusEnum";
import { useCallback, useEffect, useState } from "react";
import { StatusSelectDialogProps } from "./interfaces";

export const useStatusSelectDialogHooks = (props: StatusSelectDialogProps) => {
  const [statuses, setStatuses] = useState<StatusSelectDialogProps["statuses"]>(
    props.statuses
  );
  const [busy, setBusy] = useState(false);

  const onStatusClick = useCallback((status: StatusNameEnum) => {
    setStatuses((prev) => {
      if (prev.includes(status)) {
        return prev.filter((v) => v !== status).slice();
      } else {
        return [...prev, status];
      }
    });
  }, []);

  const onOkClick = useCallback(() => {
    // OKボタンクリック時
    setBusy(true);
  }, []);

  useEffect(() => {
    setTimeout(() => setStatuses(props.statuses), 0);
  }, [props.statuses]);

  useEffect(() => {
    if (busy) {
      props.onOkClick(statuses);
      setTimeout(() => setBusy(false), 0);
    }
  }, [busy, statuses, props]);

  return { statuses, busy, onStatusClick, onOkClick } as const;
};
